<script>
import resources from './resources'

export default {
  name: 'auth-reset',
  mixins: [resources]
}
</script>

<template lang="pug">
  .authentication
    .container
      loading(
        :active.sync='loading',
        :can-cancel='true',
        :is-full-page='fullPage',
        color='#7159c1'
      )
      .col-md-12.content-center
        .row
          .col-lg-6.col-md-12
            .company_detail
              h4.logo
                img(src='/static/images/logo.svg', alt='')
                |  Condomum
              h3
                strong Bem Vindo
              p
                | Acesse seu condominio de forma rápida, prática e segura 24hrs por dia em qualquer lugar.
              .footer
                //-ul.social_link.list-unstyled
                  li
                    a(href='https://thememakker.com', title='ThemeMakker')
                      i.zmdi.zmdi-globe
                  li
                    a(href='https://themeforest.net/user/thememakker', title='Themeforest')
                      i.zmdi.zmdi-shield-check
                  li
                    a(href='https://www.linkedin.com/company/thememakker/', title='LinkedIn')
                      i.zmdi.zmdi-linkedin
                  li
                    a(href='https://www.facebook.com/thememakkerteam', title='Facebook')
                      i.zmdi.zmdi-facebook
                  li
                    a(href='http://twitter.com/thememakker', title='Twitter')
                      i.zmdi.zmdi-twitter
                  li
                    a(href='http://plus.google.com/+thememakker', title='Google plus')
                      i.zmdi.zmdi-google-plus
                  li
                    a(href='https://www.behance.net/thememakker', title='Behance')
                      i.zmdi.zmdi-behance
                hr
                //-ul
                  li
                    a(href='http://thememakker.com/contact/', target='_blank') Contact Us
                  li
                    a(href='http://thememakker.com/about/', target='_blank') About Us
                  li
                    a(href='http://thememakker.com/services/', target='_blank') Services
                  li
                    a(href='javascript:void(0);') FAQ
          .col-lg-5.col-md-12.offset-lg-1
            .card-plain
              .header
                h5 Alterar Senha
              form.form
                v-input(:status="$v.reset.password.$error ? 'error' : null")
                  .input-group
                    input.form-control(
                      type='password',
                      v-model="reset.password"
                      placeholder='Nova Senha'
                    )
                    span.input-group-addon
                      i.zmdi.zmdi-lock

                v-input(:status="$v.reset.password_confirmation.$error ? 'error' : null")
                  .input-group
                    input.form-control(
                      type='password',
                      v-model="reset.password_confirmation"
                      placeholder='Repita a Senha'
                    )
                    span.input-group-addon
                        i.zmdi.zmdi-lock
              .footer
                a.btn.btn-primary.btn-round.btn-block(@click.prevent="doReset()", style="color: #fff;") ALTERAR
                strong(style="color: #f96332; font-size: 12px;") {{ msg }}
              a.link
</template>



// WEBPACK FOOTER //
// src/app/auth/reset/reset.vue